import { render, staticRenderFns } from "./Bhkccx.vue?vue&type=template&id=c3787188&scoped=true"
import script from "./Bhkccx.vue?vue&type=script&lang=js"
export * from "./Bhkccx.vue?vue&type=script&lang=js"
import style0 from "./Bhkccx.vue?vue&type=style&index=0&id=c3787188&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3787188",
  null
  
)

export default component.exports